import { selectMatchingVideoSource } from '../utils';

export class VideoModule {
	constructor(element) {
		this.element = element;
		this.video = this.element.querySelector('video');
		this.playButton = this.element.querySelector('[data-play-button]');
		this.poster = this.element.querySelector('[data-poster]');

		if (!this.video) {
			return;
		}

		selectMatchingVideoSource(this.video).then(() => {});

		if (this.playButton) {
			this.playButton.addEventListener('click', () => {
				this.start();
			});
		}
	}

	start() {
		this.video.play();
		this.playButton.remove();

		if (this.poster?.parentElement) {
			this.poster.parentElement.remove();
		}

		this.element.classList.add('is-clicked');
	}
}

document.addEventListener('bless', (e) => {
	const videoModules = e.target.querySelectorAll('[data-video-module]');

	videoModules.forEach((videoModule) => {
		new VideoModule(videoModule);
	});
});
